// @flow

import * as Immutable from 'immutable';

// -----------------------------------------------------------------------------------------------------------------
// Main function
// -----------------------------------------------------------------------------------------------------------------

/**
 *
 * @param {*}      updatedState New state to compare to the base
 * @param {*}      baseState    Base state to compare against
 * @param {object} [ignoreTree] Object detailing changes to ignore.
 *                              Should be an object of recursive objects, with the final object value being set to a '*'
 *                              Also supports wildcard object keys.
 *                              Example…
 *                              {
 *                                router: '*',
 *                                form: {
 *                                  '*': {
 *                                    fields: '*',
 *                                    registeredFields: '*',
 *                                  }
 *                                }
 *                              }
 * @return {Array}
 */
const compareUpdatedStateWithBase = (updatedState: *, baseState: *, ignoreTree: { [string]: {} | '*' } = {}) => {
  if (updatedState === baseState) {
    return [];
  }

  if ((Immutable.isImmutable(baseState) && baseState.equals(updatedState))) {
    return [];
  }

  if (updatedState instanceof Immutable.Map) {
    return updatedState.reduce((changed, value: *, key: string) => {

      if ('*' === ignoreTree[key]) {
        return changed;
      }

      if ('*' === ignoreTree[key]
        || (
          Immutable.isImmutable(baseState)
          && (
            value === baseState.get(key)
            || (Immutable.isImmutable(baseState.get(key)) && baseState.get(key).equals(value))
          )
        )
      ) {
        return changed;
      }

      if (!ignoreTree[key] && !ignoreTree['*']) {
        return changed.concat([[key]]);
      }

      const nextIgnoreTree = Object.assign({}, ignoreTree[key], ignoreTree['*']);

      const deeperChanges = compareUpdatedStateWithBase(value, baseState.get(key), nextIgnoreTree);
      return changed.concat(deeperChanges.map(deeperChange => [key, ...deeperChange]));

    }, []);
  }

  console.log(updatedState, baseState, ignoreTree);

  throw new Error('Unhandled condition');
};

// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default compareUpdatedStateWithBase;



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/utils/compareUpdatedStateWithBase.js